import { render, staticRenderFns } from "./SaveForTypeOption.vue?vue&type=template&id=f347e724&"
import script from "./SaveForTypeOption.vue?vue&type=script&lang=ts&"
export * from "./SaveForTypeOption.vue?vue&type=script&lang=ts&"
import style0 from "./SaveForTypeOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports